export default 'quiz-landing'
